var map = {
	"./aleman.svg": "48a4",
	"./catalan.svg": "3ff4",
	"./espanol.svg": "19c8",
	"./estadosunidense.svg": "e618",
	"./euskera.svg": "e61c",
	"./finlandes.svg": "c2e2",
	"./frances.svg": "f24f",
	"./holandes.svg": "6e29",
	"./hungaro.svg": "3254",
	"./ingles.svg": "7718",
	"./italiano.svg": "7e3d",
	"./noruego.svg": "8ceb",
	"./portugues.svg": "c768",
	"./ruso.svg": "3159",
	"./sueco.svg": "068a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a745";